<template>
  <b-row class="grab">
    <b-col class="col-main-pad">
      <b-row>
        <b-col lg="12" class="col-head-activity">
          <font-awesome-icon icon="male" />&nbsp; Configurar Ahorcado
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <label for="name">Instrucciones de la Actividad</label>
            <b-form-textarea
              v-model="instrucciones"
              placeholder="Ingrese las Instrucciones para Realizar la Actividad"
              rows="2"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
  </b-row>
</template>

<script>
var arry = new Array(26);
var noPalabras = [];
for (let i = 1; i < arry.length; i++) {
  noPalabras.push(i);
}
import OptionsElement from "./OptionsElement";
export default {
  name: "HangMan",
  data() {
    return {
      instrucciones: this.desc,
      defaultSelected: null,
      noPalabras: noPalabras,
      palabrasSelected: this.palabras
    };
  },
  props: {
    palabras: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    desc: { type: String },
    idElement: { type: Number },
    idColumn: { type: Number, default: null }
  },
  components: {
    OptionsElement
  },
  methods: {
    onChangePalabras(number) {
      this.palabrasSelected = [];
      var palabrasArry = new Array(number);
      for (let i = 0; i < palabrasArry.length; i++) {
        let palabraData = {
          id: i + 1,
          palabra: ""
        };
        this.palabrasSelected.push(palabraData);
      }
    },
    removePalabra(index) {
      this.$swal({
        type: "warning",
        title: "¡ELIMINAR UNA PALABRA!",
        text: `¿Seguro que Deseas Eliminar la Palabra No. ${index + 1}?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sí, Eliminar"
      }).then(result => {
        if (result.value) {
          this.palabrasSelected.splice(index, 1);
        }
      });
    },
    newPalabra() {
      var i = this.palabrasSelected.length;
      var palabraData = {
        id: i + 1,
        palabra: ""
      };
      this.palabrasSelected.push(palabraData);
    }
  },
  watch: {
    palabrasSelected: {
      handler: function(change) {
        this.$store.dispatch("constructor/updateContentElement", {
          indexElement: this.idElement,
          data: change,
          field: "palabras",
          indexColumns: this.idColumn
        });
      },
      deep: true
    },
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>